/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendBusinessAngelVariantDto } from '../../models/backend-business-angel-variant-dto';

export interface VentureFundsBusinessAngelVariantsRetrieve$Params {
  id: number;
}

export function ventureFundsBusinessAngelVariantsRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: VentureFundsBusinessAngelVariantsRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendBusinessAngelVariantDto>> {
  const rb = new RequestBuilder(rootUrl, ventureFundsBusinessAngelVariantsRetrieve.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendBusinessAngelVariantDto>;
    }),
  );
}

ventureFundsBusinessAngelVariantsRetrieve.PATH = '/api/venture_funds/business-angel-variants/{id}/';
